module.exports = __webpack_public_path__ + "static/media/logo_asseverato_blu_bold.17728f76.png";